module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "business"
  }, [_c('div', {
    staticClass: "title-block"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v("PROGRAM")]), _c('div', {
    staticClass: "cn"
  }, [_vm._v("学习交流")])]), _c('div', {
    staticClass: "text-block"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/business/workshop.jpg")
    }
  }), _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "cn"
  }, [_vm._v("前沿工作坊")]), _c('div', {
    staticClass: "en"
  }, [_vm._v("forontier workshop")])]), _c('div', {
    staticClass: "desc"
  }, [_c('p', [_vm._v("深入了解全球最领先的科技，提供市场化视角的思考、对未来产品与应用的建议，为实验室项目商业化提供路径。")]), _c('div', {
    staticClass: "more"
  }, [_c('a', {
    attrs: {
      "href": "/intro#workshop"
    }
  }, [_vm._v("了解更多 >")])])])]), _c('div', {
    staticClass: "text-block"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/business/fieldstudy.jpg")
    }
  }), _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "cn"
  }, [_vm._v("近场研究")]), _c('div', {
    staticClass: "en"
  }, [_vm._v("Field Study")])]), _c('div', {
    staticClass: "desc"
  }, [_c('p', [_vm._v("CEO 对 CEO，真问题对真问题。每期走进一家优秀热门科技公司，通过 CEO 间内部探讨和闭门交流，促进有价值的思考，推动经验分享与洞见碰撞，推动没有边界的创新思维和合作可能。")]), _c('div', {
    staticClass: "more"
  }, [_c('a', {
    attrs: {
      "href": "/intro#fieldstudy"
    }
  }, [_vm._v("了解更多 >")])])])]), _c('div', {
    staticClass: "title-block"
  }, [_c('div', {
    staticClass: "en"
  }, [_vm._v("Overclocking")]), _c('div', {
    staticClass: "en"
  }, [_vm._v("camp")]), _c('div', {
    staticClass: "cn"
  }, [_vm._v("超频之旅")])]), _c('div', {
    staticClass: "text-block"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/business/overclocking.jpg")
    }
  }), _c('div', {
    staticClass: "desc"
  }, [_c('p', [_vm._v("与最优秀的企业家一起在全球范围内从前沿的科技到创新的思想，去寻求认知的突破和升级，也在共同的交流和思考之中进行思维的徒步。")]), _c('div', {
    staticClass: "more"
  }, [_c('a', {
    attrs: {
      "href": "/intro#overclocking"
    }
  }, [_vm._v("了解更多 >")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-325fbc9c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Business.vue
// module id = 196
// module chunks = 1